module.exports = __webpack_public_path__ + "static/4-f5051c4cb09ba4a920adbc71f3764210.jpg";